import { css } from '@emotion/react';
import type * as React from 'react';

const listStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	margin: 0;
	padding: 0;
	list-style: none;
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The vertical list of `PersonRow`s of a `PeoplePanel`. */
const PeopleList: React.FC<Props> = ({ children }) => {
	return <ul css={listStyle}>{children}</ul>;
};

export default PeopleList;
